import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isSignInWithEmailLink } from 'firebase/auth';
import { auth } from 'utils/firebase';

import Loader from 'components/Loader';

export default function ProtectedRoute({
  children,
  redirectPath = '/sign-in',
  onlyArtist = false,
  onlyAmbassador = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.auth.isLoading);

  // Track if we're processing an email verification link
  const [isEmailVerification, setIsEmailVerification] = useState(false);

  useEffect(() => {
    // Check if this is an email verification link
    if (isSignInWithEmailLink(auth, window.location.href)) {
      setIsEmailVerification(true);
      // Give extra time for email verification to complete
      const timer = setTimeout(() => {
        setIsEmailVerification(false);
      }, 5000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    // Don't navigate while still loading auth state or processing email verification
    if (isLoading || isEmailVerification) return;

    // If no user or token, redirect to sign-in
    if (!user || !user.token) {
      navigate(redirectPath, { replace: true });
      return;
    }

    if (user.data) {
      if (!user.data.type && location.pathname !== '/setup') {
        navigate('/setup');
        return;
      }

      if (user.data.type && location.pathname === '/setup') {
        navigate('/my-chest');
        return;
      }

      if (onlyAmbassador && user.data.ambassador === false) {
        navigate('/setup');
        return;
      }
    }
  }, [isLoading, isEmailVerification, user, location.pathname, navigate, redirectPath, onlyAmbassador]);

  // Show loader while auth state is loading, processing email verification, or if no user
  if (isLoading || isEmailVerification || !user) {
    return <Loader />;
  }

  return children;
}
